<template>
  <v-dialog
    scrollable
    @keydown.esc="dismiss"
    class="nx-fullscreen-dialog-wrapper"
    :content-class="hideScroll ? 'overflow-y-hidden' : ''"
    fullscreen
    persistent
    hide-overlay
    lazy
    transition="dialog-bottom-transition"
    :value="active"
  >
    <v-card>
      <v-toolbar dark :color="color" :fixed="fixToolbar" :height="toolbarHeight" class="dialog-toolbar">
        <v-btn icon dark @click.native="dismiss">
          <v-icon color="accent" v-if="back">arrow_back</v-icon>
          <v-icon color="accent" v-else>close</v-icon>
        </v-btn>
        <v-toolbar-title :class="{ 'small-title': smallTitle }">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <slot name="toolbar-items"></slot>
        </v-toolbar-items>
        <slot name="toolbar-elements"></slot>
      </v-toolbar>

      <div class="dialog-body" :class="classes">
        <slot name="default"></slot>
      </div>

    </v-card>
  </v-dialog>
</template>

<script>
import uuid from 'uuid/v4';

export default {
  name: 'nx-fullscreen-dialog',
  props: {
    active: {
      type: Boolean,
    },
    classes: {
      type: String,
    },
    dismissable: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
    },
    color: {
      type: String,
      default: 'nx-primary--darken-2',
    },
    toolbarHeight: {
      type: [Number, String],
    },
    smallTitle: {
      type: Boolean,
    },
    back: {
      type: Boolean,
    },
    fixToolbar: {
      type: Boolean,
    },
    hideScroll: {
      type: Boolean,
    },
  },
  data() {
    return {
      id: uuid(),
    };
  },
  methods: {
    dismiss() {
      if (this.dismissable) this.$emit('dismiss');
    },
  },
  watch: {
    active: {
      handler(val) {
        this.$store.dispatch(val ? 'FULLSCREEN_DIALOG_OPENED' : 'FULLSCREEN_DIALOG_CLOSED', this.id);
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.$store.dispatch('FULLSCREEN_DIALOG_CLOSED', this.id);
  },
};
</script>

<style lang="stylus">
.dialog-body {
  height: 100%;
  overflow-y: auto;
  position: relative;
}

.dialog-toolbar {
  .small-title{
    font-size: 16px;
    margin-left: 0px;
  }
}
.v-toolbar--fixed + .dialog-body {
  margin-top: 64px
}

</style>
